import { Fragment } from 'react'

/**
 * テキスト内のメールアドレスを `<a href="mailto:..." class="hl-email">` でハイライトする。
 *
 * 主用途: エラーメッセージ (「アカウントの削除」「サポートに連絡」) で
 * info@gomoal.co.jp 等を視覚的に強調 + クリックして即メーラー起動できるようにする。
 *
 * 設計判断:
 *   - dangerouslySetInnerHTML を使わない (i18n 経由の文字列に HTML を混ぜない → XSS 安全)
 *   - 全てのメール RFC を網羅する正規表現は重いため、現実的にユーザーに見せる
 *     アドレス形式 (英数字 + 一部記号) に絞った簡易パターンを使う
 *   - 文字列を split してセグメント単位で render する
 */

// 一般的な email 形式: ローカル部 + @ + ドメイン + TLD (最低 2 文字)
// 注釈用テキスト中に出現するアドレスを抽出する用途なので、簡易パターンで十分。
const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g

export interface HighlightEmailsProps {
  /** 描画するプレーンテキスト (i18n からの文字列) */
  text: string
}

export const HighlightEmails = ({ text }: HighlightEmailsProps): JSX.Element => {
  const segments: Array<{ kind: 'text' | 'email'; value: string }> = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  EMAIL_PATTERN.lastIndex = 0
  while ((match = EMAIL_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ kind: 'text', value: text.slice(lastIndex, match.index) })
    }
    segments.push({ kind: 'email', value: match[0] })
    lastIndex = match.index + match[0].length
  }
  if (lastIndex < text.length) {
    segments.push({ kind: 'text', value: text.slice(lastIndex) })
  }

  return (
    <>
      {segments.map((seg, i) =>
        seg.kind === 'email' ? (
          <a key={i} className="hl-email" href={`mailto:${seg.value}`}>
            {seg.value}
          </a>
        ) : (
          <Fragment key={i}>{seg.value}</Fragment>
        ),
      )}
    </>
  )
}
